import React from "react";
import { PlyExportation, columns } from "./columns";
import { DataTable, DataTableBaseProps } from "./data-table";

interface PlyExportationTableProps extends DataTableBaseProps {
  data: PlyExportation[];
}

export const PlyExportationTable = (props: PlyExportationTableProps) => {
  return (
    <div className="mx-auto py-4">
      <DataTable columns={columns} {...props} />
    </div>
  );
};
